module.exports = __webpack_public_path__ + "img/stamp3.e227a696.png";